import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { FolderTemplateAssignmentModel, FolderTemplateModel, SaveFolderAssignmentsRequest } from '../models/folder-template.model';

@Injectable({
  providedIn: 'root'
})
export class FolderTemplateService {
  constructor(private apiService: ApiService) {}

  getFolderTemplates(): Observable<FolderTemplateModel[]> {
    return this.apiService.get('FolderTemplate/GetFolderTemplates');
  }

  createFolderTemplate(folderName: string): Observable<number> {
    return this.apiService.post('FolderTemplate/CreateFolderTemplate', { folderName });
  }

  deleteFolderTemplate(id: number): Observable<boolean> {
    return this.apiService.delete(`FolderTemplate/DeleteFolderTemplate/${id}`);
  }

  getAssignmentsByProject(projectId: number): Observable<FolderTemplateAssignmentModel[]> {
    return this.apiService.get(`FolderTemplate/GetAssignmentsByProject/${projectId}`);
  }

  saveAssignments(request: SaveFolderAssignmentsRequest): Observable<boolean> {
    return this.apiService.post('FolderTemplate/SaveAssignments', request);
  }

  getMyTemplateFolders(projectId: number): Observable<FolderTemplateModel[]> {
    return this.apiService.get(`FolderTemplate/GetMyFolders/${projectId}`);
  }
}
